import { TypedUseSelectorHook, shallowEqual, useDispatch, useSelector } from "react-redux";

import type { AppDispatch, AppRootState, AppThunkDispatch } from "@/store";

// Define react-redux typed hooks
// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://react-redux.js.org/tutorials/typescript-quick-start#define-typed-hooks
export const useAppDispatch: () => AppDispatch = useDispatch<AppDispatch>;
export const useAppThunkDispatch: () => AppThunkDispatch = useDispatch<AppThunkDispatch>;
export const useAppSelector: TypedUseSelectorHook<AppRootState> = useSelector;

export function useShallowEqualSelector<TSelected>(selector: (state: AppRootState) => TSelected) {
  return useAppSelector(selector, shallowEqual);
}
